import type { ReactNode } from 'react';
import { badgeBase, badgeTone, badgeDot } from './badge.css';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'critical' | 'primary';

export interface BadgeProps {
    children: ReactNode;
    tone?: BadgeTone;
    /** Leading status dot (Untitled UI "dot leading" badge). */
    dot?: boolean;
    testID?: string;
}

/** Pill status badge: subtle tinted fill, 1px ring, optional leading dot. */
export function Badge({ children, tone = 'neutral', dot = false, testID }: BadgeProps) {
    return (
        <span className={`${badgeBase} ${badgeTone[tone]}`} data-testid={testID}>
            {dot ? <span className={badgeDot} aria-hidden /> : null}
            {children}
        </span>
    );
}
